// Single source for $.fn.dropdown: every controller touching a Fomantic
// dropdown imports this file, so the whole app shares one version and the
// global settings below apply regardless of which controller loads first.
import 'fomantic-ui-css/components/dropdown'
import 'semantic-ui-transition/transition'

// Fomantic 2.9 changed the default to false; the app relies on menus opening on focus.
$.fn.dropdown.settings.showOnFocus = true

$.fn.dropdown.settings.message.addResult = 'Ajouter <b>{term}</b>'
$.fn.dropdown.settings.message.count = '{count} sélectionnés'
$.fn.dropdown.settings.message.maxSelections = '{maxCount} sélections maximum'
$.fn.dropdown.settings.message.noResults = 'Aucun résultat trouvé'
